import PropTypes from 'prop-types';
import { Card } from '@etg/wings';
import { useTranslation } from '@eti/providers';
import { css } from '@eti/styles';
import { Overlay } from '@eti/components';
import { TravelerNames } from './CartProduct';

const travelerNamesStyles = css`
  margin-top: 16px;
`;
const cardStyles = css`
  overflow-x: auto;
`;
const textStyles = css`
  white-space: pre;
`;

const CartProductOverlay = ({ onClose, isOpen, text, title, travelers }) => {
  const { t } = useTranslation();
  const contentHeaderText = t('Product.ReadMoreOverlay.ContentHeader.Label');

  return (
    <Overlay.Drawer dataTestId="cartProduct-overlay" handleClose={onClose} isOpen={isOpen}>
      <Overlay.Header onClose={onClose} title={title} />
      <Overlay.Content data-testid="cartProduct-overlay-content">
        <Card className={cardStyles}>
          {contentHeaderText && <Overlay.CardTitle>{contentHeaderText}</Overlay.CardTitle>}
          <div className={textStyles}>{text}</div>
          {travelers?.length > 0 && (
            <TravelerNames className={travelerNamesStyles}>
              {travelers.map(({ firstName, lastName }) => (
                <div key={`${firstName}-${lastName}`}>
                  {firstName} {lastName}
                </div>
              ))}
            </TravelerNames>
          )}
        </Card>
      </Overlay.Content>
    </Overlay.Drawer>
  );
};

CartProductOverlay.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  text: PropTypes.string,
  title: PropTypes.string,
  travelers: PropTypes.arrayOf(
    PropTypes.shape({
      firstName: PropTypes.string,
      lastName: PropTypes.string,
    }),
  ),
};

export default CartProductOverlay;
